import { render, staticRenderFns } from "./AvatarUploader.vue?vue&type=template&id=49ea2f82&scoped=true&"
import script from "./AvatarUploader.vue?vue&type=script&lang=js&"
export * from "./AvatarUploader.vue?vue&type=script&lang=js&"
import style0 from "./AvatarUploader.vue?vue&type=style&index=0&id=49ea2f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ea2f82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49ea2f82')) {
      api.createRecord('49ea2f82', component.options)
    } else {
      api.reload('49ea2f82', component.options)
    }
    module.hot.accept("./AvatarUploader.vue?vue&type=template&id=49ea2f82&scoped=true&", function () {
      api.rerender('49ea2f82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/forms/AvatarUploader.vue"
export default component.exports